import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../../mock';
import { scrollToSection } from './scroll';
import { SocialLinks } from './SocialLinks';

export const SiteFooter = () => (
      <footer className="bg-gray-900 border-t border-gray-800 text-white py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_jetco-electrical/artifacts/x1j92naa_Untitled%20design.png" 
                  alt="Jetco Electrical" 
                  className="h-12 w-auto"
                />
              </div>
              <p className="text-gray-400">Your trusted electrical experts in Brooklyn and surrounding areas.</p>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-yellow-400">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li><button onClick={() => scrollToSection('services')} className="hover:text-yellow-400 transition-colors">Services</button></li>
                <li><button onClick={() => scrollToSection('about')} className="hover:text-yellow-400 transition-colors">About Us</button></li>
                <li><Link to="/gallery" className="hover:text-yellow-400 transition-colors">Gallery</Link></li>
                <li><Link to="/blog" className="hover:text-yellow-400 transition-colors">Blog</Link></li>
                <li><button onClick={() => scrollToSection('testimonials')} className="hover:text-yellow-400 transition-colors">Testimonials</button></li>
                <li><button onClick={() => scrollToSection('contact')} className="hover:text-yellow-400 transition-colors">Contact</button></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-yellow-400">Services</h3>
              <ul className="space-y-2 text-gray-400">
                <li className="hover:text-cyan-400 transition-colors">EV Charger Installation</li>
                <li className="hover:text-cyan-400 transition-colors">Smart Home Systems</li>
                <li className="hover:text-cyan-400 transition-colors">Panel Upgrades</li>
                <li className="hover:text-cyan-400 transition-colors">Emergency Repairs</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-yellow-400">Contact</h3>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center space-x-2">
                  <Phone className="w-4 h-4 text-cyan-400" />
                  <a href={`tel:${companyInfo.phone}`} className="hover:text-yellow-400 transition-colors">{companyInfo.phone}</a>
                </li>
                <li className="flex items-center space-x-2">
                  <Mail className="w-4 h-4 text-cyan-400" />
                  <a href={`mailto:${companyInfo.email}`} className="hover:text-yellow-400 transition-colors">{companyInfo.email}</a>
                </li>
                <li className="flex items-center space-x-2">
                  <Clock className="w-4 h-4 text-cyan-400" />
                  <span>{companyInfo.hours}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p className="mb-4">&copy; 2025 {companyInfo.name}. All rights reserved.</p>
            <div className="flex flex-col items-center space-y-2">
              <p className="text-sm text-gray-500">Follow us:</p>
              <SocialLinks idPrefix="footer" />
            </div>
          </div>
        </div>
      </footer>
);
